import { render, staticRenderFns } from "./materialListBox.vue?vue&type=template&id=cadc5428&scoped=true&"
import script from "./materialListBox.vue?vue&type=script&lang=js&"
export * from "./materialListBox.vue?vue&type=script&lang=js&"
import style0 from "./materialListBox.vue?vue&type=style&index=0&lang=less&"
import style1 from "./materialListBox.vue?vue&type=style&index=1&id=cadc5428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadc5428",
  null
  
)

component.options.__file = "materialListBox.vue"
export default component.exports